<template>
  <article>
    <section id="home-two">
      <div class="wrapper">
        <div class="subhead fill">
          <span>产品优势</span>
        </div>
        <div class="p1-box">
          <div class="pure-g">
            <div style="line-height: 30px;" class="pure-u-1 pure-u-xl-1-1" v-if="superiorityListContant">
              <p v-html="superiorityListContant"></p>
            </div>
          </div>
        </div>
        <div class="p0-box">
          <div class="pure-u-1 pure-u-xl-1-1">
            <div class="history-box" v-for="(item, index) in superiorityListImg" :key="index">
              <img :src="'https://himifi.cn/api/admin/getImage?path=' + item.imageUrl" oncontextmenu="return false;" />
            </div>
          </div>
        </div>
        <div class="subhead fill">
          <span>产品介绍</span>
        </div>
        <div class="p0-box" style="margin-top: 30px;">
          <div class="pure-u-1 pure-u-xl-1-1">
            <div class="history">
              <video class="videoMp" controls muted loop>
                <source src="https://himifi-soft-1.oss-cn-wulanchabu.aliyuncs.com/commercialVideo/sucai01.mp4"
                  type="video/mp4">
              </video>
              <video class="videoMp" controls muted loop>
                <source src="https://himifi-soft-1.oss-cn-wulanchabu.aliyuncs.com/commercialVideo/sucai02.mp4"
                  type="video/mp4">
              </video>
              <video class="videoMp" controls muted loop>
                <source src="https://himifi-soft-1.oss-cn-wulanchabu.aliyuncs.com/commercialVideo/sucai03.mp4"
                  type="video/mp4">
              </video>
            </div>
          </div>
        </div>
      </div>
    </section>
  </article>
</template>

<script>
export default {
  name: "Product",
  data() {
    return {
      superiorityListImg: [],
      superiorityListContant: '',
      // 轮播图
      swiperList: [],
      curLunbo: 1,
      swiperOption: {
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
        // loop: true,
        breakpoints: {
          768: {  //当屏幕宽度大于等于768 
            slidesPerView: 1,
            spaceBetween: 3
          },
          1280: {  //当屏幕宽度大于等于1280
            slidesPerView: 1,
            spaceBetween: 3
          },
          1440: {  //当屏幕宽度大于等于1440
            slidesPerView: 1,
            spaceBetween: 3
          },
          1920: {  //当屏幕宽度大于等于1920
            slidesPerView: 1,
            spaceBetween: 3
          }
        }
      }
    }
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper
    }
  },
  created() {
    // 产品优势
    this.superiority()
  },
  methods: {
    // 产品优势
    superiority() {
      this.$http.get("/website/hnWebsiteContentInfo/getList", {
        firstType: "3"
      }, res => {
        if (res.code == '200') {
          this.superiorityListImg = res.data.产品优势[1]
          this.superiorityListContant = res.data.产品优势[3][0].content
        }
      })
    }
  }
}
</script>

<style scoped>
@import "~@/assets/styles/product.css";

.history {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

.history-img {
  display: flex;
  align-items: center;
}

.history-box>img {
  width: 100;
  height: 100%;
}
</style>
